import { HashRouter } from 'react-router-dom'

import { createRoot } from 'react-dom/client'

import { CheckoutFlowVersion } from '@/enums/payments'

import { AuthProvider } from '@/auth/provider'
import { initSessionData, SessionProvider } from '@/core/session'

import { EXPERIMENT_NAME } from './config/pages/constants'
import { pagesOrder } from './config/pages/pageOrder'
import { getItem, removeItem, setItem, setLastVisitedItem } from './config/storage'
// should be imported before every file which could use i18n
import './i18n'
import { Orgfit } from './Orgfit'

initSessionData(
  getItem,
  setItem,
  removeItem,
  pagesOrder,
  EXPERIMENT_NAME,
  setLastVisitedItem,
  false,
  CheckoutFlowVersion.V2
).then((sessionData) => {
  const rootElement = document.getElementById('root') as HTMLElement
  const root = createRoot(rootElement)
  root.render(
    <SessionProvider initialValue={sessionData}>
      <AuthProvider getItem={getItem} setItem={setItem} removeItem={removeItem}>
        <HashRouter>
          <Orgfit />
        </HashRouter>
      </AuthProvider>
    </SessionProvider>
  )
})
